/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/**
 * This file was auto-generated by `yarn generate-openapi-contracts`.
 * Do not make direct changes to the file.
 */

import { fetchAsJson, applyParameters } from '@modules/query/helpers'
import type { Exact } from '@modules/ts-essentials'

import type { operations, components } from './types'

// GET /api/v1/serverless/traffic-filters
// ts-unused-exports:disable-next-line
export const listTrafficFilters = async (args?: {
  queryParameters?: operations['listTrafficFilters']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['TrafficFilterList']>(
    applyParameters('/api/v1/serverless/traffic-filters', args),
    {
      method: 'GET',
    },
  )

// POST /api/v1/serverless/traffic-filters
// ts-unused-exports:disable-next-line
export const createTrafficFilter = async <
  T = operations['createTrafficFilter']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createTrafficFilter']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['createTrafficFilter']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createTrafficFilter']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['TrafficFilterInfo']>('/api/v1/serverless/traffic-filters', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// GET /api/v1/serverless/traffic-filters/metadata
// ts-unused-exports:disable-next-line
export const getTrafficFilterMetadata = async (args?: {
  queryParameters?: operations['getTrafficFilterMetadata']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['TrafficFilterMetadata']>(
    applyParameters('/api/v1/serverless/traffic-filters/metadata', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/traffic-filters/{id}
// ts-unused-exports:disable-next-line
export const getTrafficFilter = async (args: {
  pathParameters: operations['getTrafficFilter']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['TrafficFilterInfo']>(
    applyParameters('/api/v1/serverless/traffic-filters/{id}', args),
    {
      method: 'GET',
    },
  )

// PATCH /api/v1/serverless/traffic-filters/{id}
// ts-unused-exports:disable-next-line
export const patchTrafficFilter = async <
  T = operations['patchTrafficFilter']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['patchTrafficFilter']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['patchTrafficFilter']['parameters']['path']
  body: Exact<
    T,
    operations['patchTrafficFilter']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['patchTrafficFilter']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['TrafficFilterInfo']>(
    applyParameters('/api/v1/serverless/traffic-filters/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/serverless/traffic-filters/{id}
// ts-unused-exports:disable-next-line
export const deleteTrafficFilter = async (args: {
  pathParameters: operations['deleteTrafficFilter']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['EmptyResponse']>(
    applyParameters('/api/v1/serverless/traffic-filters/{id}', args),
    {
      method: 'DELETE',
    },
  )
